import { useState } from 'react';
import { isFunction } from 'lodash';

export const useForm = (defaultValues, validators = {}) => {
  const [state, setFormState] = useState({ values: defaultValues, errors: [] });

  const onChange = (event, config) => {
    const {
      target: {
        name, value, type, checked,
      },
    } = event;
    const typeValue = type === 'checkbox' ? checked : value;
    const { getName, getValue, onChangeCallback } = config || {};

    const propertyName = isFunction(getName) ? getName({ event, typeValue }) : name;
    const propertyValue = isFunction(getValue) ? getValue({ event, typeValue }) : typeValue;

    const errors = {};
    const inputValidators = validators[name] || [];

    inputValidators.forEach(
      (validator) => {
        const error = validator(propertyValue);

        if (error) {
          if (!errors[propertyName]) errors[propertyName] = [];
          errors[propertyName].push(error);
        }
      },
    );

    const updatedState = {
      ...state,
      errors,
      values: {
        ...state.values,
        [propertyName]: propertyValue,
      },
    };

    setFormState(updatedState);

    if (isFunction(onChangeCallback)) onChangeCallback(updatedState.values);
  };

  return { state, onChange };
};

export const makeDateTimeHandler = (config) => (moment) => {
  if (!moment) return;
  const { name, call, format = 'x' } = config;

  call({ target: { name, type: 'datetime', value: moment.format(format) } });
};
